<script lang="ts">
  import { Button } from "@/lib/components/ui/button";
  import AchievementCard from "./AchievementCard.svelte";
  import { onMount, tick } from "svelte";
  import { kmToMile, meterToFoot, round } from "@/Util/utils";
  import FactCard from "./FactCard.svelte";
  import { format } from "date-fns";
  import { cn } from "@/lib/utils";
  import TotalsActivityCard from "./TotalsActivityCard.svelte";
  import TotalsTrainingCard from "./TotalsTrainingCard.svelte";
  import TotalsNutritionCard from "./TotalsNutritionCard.svelte";
  import RecordsStrainCard from "./RecordsStrainCard.svelte";
  import RecordsPowerCard from "./RecordsPowerCard.svelte";
  import RecordsTerrainCard from "./RecordsTerrainCard.svelte";
  import TrainingPlanRestCard from "./TrainingPlanRestCard.svelte";
  import TrainingPlanAdherenceCard from "./TrainingPlanAdherenceCard.svelte";
  import TrainingPlanStreakCard from "./TrainingPlanStreakCard.svelte";
  import GroupActivitiesCard from "./GroupActivitiesCard.svelte";
  import TotalDistanceCard from "./TotalDistanceCard.svelte";
  import GlobalAverageSignatureCard from "./GlobalAverageSignatureCard.svelte";
  import BreakThroughsCard from "./BreakThroughsCard.svelte";
  import GlobalAverageOtherCard from "./GlobalAverageOtherCard.svelte";

  export let year: number;

  export let gold_brs;
  export let silver_brs;
  export let bronze_brs;

  export let max_difficulty_a;
  export let max_signature_ftp_p;
  export let max_signature_ftp_a;
  export let max_xep_a;
  export let max_mep_a;
  export let max_power_a;
  export let max_hr_a;
  export let max_tgf_a;
  export let max_tgc_a;
  export let max_xss_a;
  export let max_xhss_a;
  export let max_xpss_a;
  export let max_kge_a;
  export let kge_change;
  export let max_avg_relative_power_a;
  export let max_distance_a;

  export let max_signature_pp;
  export let max_signature_hie;
  export let max_watts_per_kg;

  export let energizer_rating: number;
  export let previous_year: any;
  export let fake_brs: number;
  export let total_carbs: number;
  export let total_fat: number;
  export let total_xss: number;
  export let number_activities: number;
  export let training_status: { ts_rating: number };
  export let max_tl_p: any;
  export let improvement_rate: string;
  export let highest_ramp_start: any;
  export let highest_ramp_end: any;
  export let xert_workouts: number;
  export let total_distance: number;
  export let distance_unit: string;
  export let total_time: number;
  export let total_elevation_gain: number;
  export let elevation_unit: string;
  export let indoor_rides: number;
  export let outdoor_rides: number;
  export let number_active_days: number;

  export let number_days_on_forecast_plan: number;
  export let number_forecasted_rest_days: number;
  export let number_forecasted_rest_days_with_activity: number;
  export let number_forecasted_training_missed_days: number;
  export let number_green_circles: number;
  // export let number_yellow_circles: number;
  // export let number_red_circles: number;
  export let longest_green_circles_streak: number;

  export let number_group_rides: number;
  export let biggest_group_ride: any;

    // "total_users_attempted" => 59693,
    // "total_users" => 5816,
    // "total_activities" => 1160542,
    // "total_distance" => 39928493.496687,
    // "average_ftp" => 268.0,
    // "average_pp" => 1045.0,
    // "average_hie" => 23133.0,
    // "average_watts_per_kg" => 3.5,
    // "total_users_2024" => 4443,
    // "total_activities_2024" => 868332,
    // "total_distance_2024" => 30454832.087919,
    // "average_ftp_2024" => 268.0,
    // "average_pp_2024" => 1048.0,
    // "average_hie_2024" => 23238.0,
    // "average_watts_per_kg_2024" => 3.52,

    // Alternate query
    // "total_users_attempted" => 59695,
    // "total_users" => 8437,
    // "total_activities" => 1560236,
    // "total_distance" => 54385567.973073,
    // "average_ftp" => 278.0,
    // "average_pp" => 1074.0,
    // "average_hie" => 23925.0,
    // "average_watts_per_kg" => 3.66,
    // "total_users_2024" => 8832,
    // "total_activities_2024" => 1573784,
    // "total_distance_2024" => 55639885.75585,
    // "average_ftp_2024" => 276.0,
    // "average_pp_2024" => 1074.0,
    // "average_hie_2024" => 23970.0,
    // "average_watts_per_kg_2024" => 3.68,
  const AVERAGES_MALE = {
    people: 8437,
    avg_highest_threshold_power: 278,
    avg_highest_peak_power: 1074,
    avg_highest_hie: round(23925 / 1000, 1),
    number_activities: round(1560236 / 8437),
    yearly_distance_km: round(54385567 / 8437),
    watts_per_kg: 3.66,
  };
  const AVERAGES_MALE_2024 = {
    people: 8832,
    avg_highest_threshold_power: 276,
    avg_highest_peak_power: 1074,
    avg_highest_hie: round(23970 / 1000, 1),
    number_activities: round(1573784 / 8832),
    yearly_distance_km: round(55639885 / 8832),
    watts_per_kg: 3.68,
  };
  // "total_users_attempted" => 3368,
  // "total_users" => 290,
  // "total_activities" => 61380,
  // "total_distance" => 1769162.05743,
  // "average_ftp" => 198.0,
  // "average_pp" => 711.0,
  // "average_hie" => 15445.0,
  // "average_watts_per_kg" => 3.25,
  // "total_users_2024" => 210,
  // "total_activities_2024" => 41486,
  // "total_distance_2024" => 1230715.85531,
  // "average_ftp_2024" => 191.0,
  // "average_pp_2024" => 704.0,
  // "average_hie_2024" => 15241.0,
  // "average_watts_per_kg_2024" => 3.14,

  // Alternate query
  // "total_users_attempted" => 3369,
  // "total_users" => 418,
  // "total_activities" => 82317,
  // "total_distance" => 2467513.30189,
  // "average_ftp" => 208.0,
  // "average_pp" => 748.0,
  // "average_hie" => 16683.0,
  // "average_watts_per_kg" => 3.45,
  // "total_users_2024" => 413,
  // "total_activities_2024" => 75349,
  // "total_distance_2024" => 2317365.23628,
  // "average_ftp_2024" => 202.0,
  // "average_pp_2024" => 768.0,
  // "average_hie_2024" => 17226.0,
  // "average_watts_per_kg_2024" => 3.33,
  const AVERAGES_FEMALE = {
    people: 418,
    avg_highest_threshold_power: 208,
    avg_highest_peak_power: 748,
    avg_highest_hie: round(16683 / 1000, 1),
    number_activities: round(82317 / 418),
    yearly_distance_km: round(2467513 / 418),
    watts_per_kg: 3.45,
  };
  const AVERAGES_FEMALE_2024 = {
    people: 413,
    avg_highest_threshold_power: 202,
    avg_highest_peak_power: 768,
    avg_highest_hie: round(17226 / 1000, 1),
    number_activities: round(75349 / 413),
    yearly_distance_km: round(2317365 / 413),
    watts_per_kg: 3.33,
  };

  const AVERAGES_ALL = {
    number_activities: (AVERAGES_MALE.number_activities * AVERAGES_MALE.people + AVERAGES_FEMALE.number_activities * AVERAGES_FEMALE.people) / (AVERAGES_MALE.people + AVERAGES_FEMALE.people),
    yearly_distance_km: (AVERAGES_MALE.yearly_distance_km * AVERAGES_MALE.people + AVERAGES_FEMALE.yearly_distance_km * AVERAGES_FEMALE.people) / (AVERAGES_MALE.people + AVERAGES_FEMALE.people),
  }
  const AVERAGES_ALL_2024 = {
    number_activities: (AVERAGES_MALE_2024.number_activities * AVERAGES_MALE_2024.people + AVERAGES_FEMALE_2024.number_activities * AVERAGES_FEMALE_2024.people) / (AVERAGES_MALE_2024.people + AVERAGES_FEMALE_2024.people),
    yearly_distance_km: (AVERAGES_MALE_2024.yearly_distance_km * AVERAGES_MALE_2024.people + AVERAGES_FEMALE_2024.yearly_distance_km * AVERAGES_FEMALE_2024.people) / (AVERAGES_MALE_2024.people + AVERAGES_FEMALE_2024.people),
  }

  let rootSize: ResizeObserverSize[] | null = null;
  let rootWidth: number | null = null;
  $: if (rootSize && rootSize[0]) rootWidth = rootSize[0].inlineSize;

  $: useMobileLayout = rootWidth > 0 && rootWidth < 768;

  type PageType = 'title' | 'longest_distance' | 'totals' | 'power_records' | 'strain_records' | 'terrain_records' | 'best_activities' | 'training_plan' | 'group_activities' | 'global_averages' | 'data' | 'last';
  let currentPage: PageType = 'title';
  let prevPage: PageType = currentPage;

  let backgroundImages = {
    'title' : year == 2025 ? 'url("/assets/images/yearly-report/2025.png")' : 'url("/assets/images/xfai/Road cyclist riding through a surreal, multi-dimensional universe.webp")',
    'longest_distance' : 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url("/assets/images/yearly-report/stamps.jpg")',
    'totals' : 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url("/assets/images/yearly-report/cyclists_blur.jpg")',
    'power_records' : 'url("/assets/images/yearly-report/sprint.png")',
    'strain_records' : 'url("/assets/images/yearly-report/marquee.jpg")',
    'terrain_records' : 'url("/assets/images/yearly-report/canyon.jpg")',
    'best_activities' : 'url("/assets/images/yearly-report/windy_road.png")',
    'training_plan' : 'url("/assets/images/xfai/Measuring Performance Cyclist.webp")',
    'group_activities' : 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url("/assets/images/yearly-report/group.jpg")',
    'global_averages' : 'url("/assets/images/yearly-report/two_cyclists.jpg")',
    'data' : 'url("/assets/images/yearly-report/cyclist_cliff_mountain.jpg")',
    'last' : 'url("/assets/images/MultiSportImage.png")',
  }

  let revealLongestDistance = false;
  
  // reveal flags for USER TOTALS cards
  let revealTotals1 = false; // Activities summary
  let revealTotals2 = false; // Training totals
  let revealTotals3 = false; // Nutrition totals

  // reveal flags for USER RECORDS cards
  let revealBreakthroughs = false; // Power breakthroughs
  let revealRecords1 = false; // Highest xss
  let revealRecords2 = false; // Highest power
  let revealRecords3 = false; // Longest and steepest

  // reveal flags for TRAINING PLAN cards
  let revealTrainingPlan1 = false; // Rest days with activities
  let revealTrainingPlan2 = false; // Days on plan vs missed
  let revealTrainingPlan3 = false; // Green circles streak
  let revealTrainingPlanTimeout1 = null;
  let revealTrainingPlanTimeout3 = null;

  // reveal flag for GROUP ACTIVITIES card
  let revealGroup = false;
  let revealGlobalSignature = false;
  let revealGlobalOther = false;

  let achievements: { title: string; subtitle: string; activity: any }[] = [];
  $: achievements = [
    {
      title: 'Longest Distance',
      subtitle: `You rode ${getDisplayDistance(max_distance_a.distance, distance_unit)} ${distance_unit} on this ride. Wow!`,
      activity: max_distance_a,
    },
    max_kge_a ? {
      title: 'Steepest Ride',
      subtitle: `This ride had a grade of ${round(getKgeGrade(max_kge_a.kge), 1)}.
        Based on your weight, you would require ${round(Math.abs(kge_change),0)} ${kge_change < 0 ? "less" : "more"} watts compared to a 75kg rider.`,
      activity: max_kge_a,
    } : null,
    {
      title: 'Most Difficult Ride',
      subtitle: `You hit a Difficulty Score of ${round(max_difficulty_a.difficulty)}. That was a ${max_difficulty_a.difficulty > 150 ? "hard" : max_difficulty_a.difficulty > 110 ? "tough" : "challenging"} ride!`,
      activity: max_difficulty_a,
    },
    {
      title: 'Highest Threshold Power',
      subtitle: `Your FTP reached ${round(max_signature_ftp_p.signature.ftp)} watts!`,
      activity: max_signature_ftp_a,
    },
    {
      title: 'Best Equivalent Power',
      subtitle: `Your highest XEP was ${round(max_xep_a.xep)} watts, based on Pedaling Time. Beast.`,
      activity: max_xep_a,
    },
    {
      title: 'Longest Time Near MPA',
      subtitle: `On this ride, you stayed near MPA for ${round(max_mep_a.mep)} seconds. ${max_mep_a.mep > 10 ? "That's nuts!" : ""}`,
      activity: max_mep_a,
    },
    {
      title: 'Highest Power Recorded',
      subtitle: `Your sprint reached ${round(max_power_a.sessions[0].max_power)} watts!`,
      activity: max_power_a,
    },
    {
      title: 'Highest Heart Rate',
      subtitle: `Your max heart rate was ${round(max_hr_a.sessions[0].max_heart_rate)} BPM`,
      activity: max_hr_a,
    },
    {
      title: 'Highest Fat Burned',
      subtitle: `You burned ${round(max_tgf_a.tgf)} grams of fat on this ride. Nicely done!`,
      activity: max_tgf_a,
    },
    {
      title: 'Most Carbs Burned',
      subtitle: `You burned ${round(max_tgc_a.tgc)} grams of carbs on this ride. I bet you were hungry afterwards.`,
      activity: max_tgc_a,
    },
    {
      title: 'Most XSS Strain Ride',
      subtitle: `You accumulated a whopping ${round(max_xss_a.xss, 1)} XSS on this ride!`,
      activity: max_xss_a,
    },
    {
      title: 'Most High Intensity Strain',
      subtitle: `Your max high intensity strain was ${round(max_xhss_a.xhss, 1)} XSS`,
      activity: max_xhss_a,
    },
    {
      title: 'Most Peak Intensity Strain',
      subtitle: `Your max peak intensity strain was ${round(max_xpss_a.xpss, 1)} XSS`,
      activity: max_xpss_a,
    },
    max_avg_relative_power_a ? {
      title: 'Highest Relative Power',
      subtitle: `Your Average XRP was ${round(max_avg_relative_power_a.avg_relative_power, 0)} watts on this ride, based on Pedaling Time.`,
      activity: max_avg_relative_power_a,
    } : null,
  ].filter(a => a !== null);

  function tl_sum(tl) {
    if (!tl['ftp']) return 1;
    return tl['ftp'] + tl['hie'] + tl['pp'];
  }

  function getDisplayDistance(distance, unit) {
    return round(unit == 'mi' ? kmToMile(distance ?? 0) : (distance ?? 0));
  }

  function getDisplayElevation(elevation, unit) {
    return round(unit == 'ft' ? meterToFoot(elevation ?? 0) : (elevation ?? 0));
  }

  let facts: { title: string; icon: string; count: string; subtitle: string; previousYear: string, color: string }[] = [];
  $: facts = [
    {
      title: 'Total Average Power Rating',
      icon: 'fa-rabbit-running',
      count: `You averaged ${round(energizer_rating)}% of your FTP over the whole year.`,
      subtitle: energizer_rating > 0.6 ? "You just don't stop!" : "Chill rides are more relaxing.",
      previousYear: previous_year && previous_year["energizer_rating"] != null && previous_year["year"] != null
        ? `${round(previous_year["energizer_rating"])}% in ${previous_year["year"]}` : "",
      color: '#5EE6E8',
    },
    {
      title: 'Fakethroughs',
      icon: 'fa-face-frown',
      count: `Total: ${round(fake_brs, 0)}`,
      subtitle: `Days of Sadness: ${round(fake_brs, 0)}`,
      previousYear: previous_year && previous_year["fake_brs"] != null && previous_year["year"] != null
        ? `${round(previous_year["fake_brs"], 0)} fakethroughs in ${previous_year["year"]}` : "",
      color: '#FF6B6B',
    },
    // {
    //   title: 'Total Calories Burned',
    //   icon: 'fa-pizza-slice',
    //   count: `${round((total_carbs * 4 + total_fat * 9), 0)} calories`,
    //   subtitle: `or ${Math.floor((total_carbs * 4 + total_fat * 9) / 285)} Slices of Pizza`,
    //   previousYear: previous_year && previous_year["total_carbs"] != null && previous_year["total_fat"] != null && previous_year["year"] != null
    //     ? `${round((previous_year["total_carbs"] * 4 + previous_year["total_fat"] * 9), 0)} calories in ${previous_year["year"]}` : "",
    //   color: '#FFD166',
    // },
    // {
    //   title: 'Total Fat Burned',
    //   icon: 'fa-weight-scale',
    //   count: `${round(total_fat)} grams`,
    //   subtitle: `or ${Math.floor(total_fat / 454)} pounds you didn't gain`,
    //   previousYear: previous_year && previous_year["total_fat"] != null && previous_year["year"] != null
    //     ? `${round(previous_year["total_fat"])} grams in ${previous_year["year"]}` : "",
    //   color: '#06D6A0',
    // },
    // {
    //   title: 'Total Carbs Burned',
    //   icon: 'fa-ice-cream',
    //   count: `${round(total_carbs)} grams of Carbs`,
    //   subtitle: `or ${Math.floor(total_carbs / 68)} Apple Fritters`,
    //   previousYear: previous_year && previous_year["total_carbs"] != null && previous_year["year"] != null
    //     ? `${round(previous_year["total_carbs"])} grams in ${previous_year["year"]}` : "",
    //   color: '#EF476F',
    // },
    // {
    //   title: 'Total XSS',
    //   icon: 'fa-chart-pyramid',
    //   count: `${round(total_xss)} XSS`,
    //   subtitle: `${Math.floor(total_xss / number_activities)} XSS on average`,
    //   previousYear: previous_year && previous_year["total_xss"] != null && previous_year["year"] != null
    //     ? `${round(previous_year["total_xss"])} XSS in ${previous_year["year"]}` : "",
    //   color: '#118AB2',
    // },
    {
      title: 'Highest Training Status',
      icon: 'fa-chart-mixed',
      count: `Training Load: ${round(tl_sum(max_tl_p.tl))}`,
      subtitle: 'Training Status: ' + `${round(training_status.ts_rating * 100, 0)}%`,
      previousYear: previous_year && previous_year["max_tl_p"] && previous_year["max_tl_p"].tl && previous_year["year"] != null
        ? `${round(tl_sum(previous_year["max_tl_p"].tl))} training load in ${previous_year["year"]}` : "",
      color: '#A0FF00',
    },
    {
      title: 'Best 4-Week Improvement',
      icon: 'fa-stairs',
      count: `Improvement Rate: ${improvement_rate}`,
      subtitle: `From ${format(new Date(highest_ramp_start), 'MMM do')} to ${format(new Date(highest_ramp_end), 'MMM do')}`,
      previousYear: "",
      color: '#F0A6CA',
    },
    // {
    //   title: 'Workouts Completed',
    //   icon: 'fa-dumbbell',
    //   count: `${xert_workouts} workouts`,
    //   subtitle: xert_workouts < 10 ? "That's it!? Get off your butt!" : "Way to kick ass!",
    //   previousYear: previous_year && previous_year["xert_workouts"] != null && previous_year["year"] != null
    //     ? `${round(previous_year["xert_workouts"], 0)} workouts in ${previous_year["year"]}` : "",
    //   color: '#FB5607',
    // },
    // {
    //   title: 'Total Distance',
    //   icon: 'fa-road',
    //   count: `${round(getDisplayDistance(total_distance))}${distance_unit}`,
    //   subtitle: `You completed the Tour de France ${round(total_distance / 3405, 1)} times`,
    //   previousYear: previous_year && previous_year["total_distance"] != null && previous_year["year"] != null
    //     ? `${round(getDisplayDistance(previous_year["total_distance"]))}${distance_unit} in ${previous_year["year"]}` : "",
    //   color: '#3A86FF',
    // },
    // {
    //   title: 'Total Saddle Time',
    //   icon: 'fa-clock',
    //   count: `${round(total_time / 3600)} hrs`,
    //   subtitle: `${round((total_time / (3600 * 365) / 16 * 100), 1)}% of your waking hours`,
    //   previousYear: previous_year && previous_year["total_time"] != null && previous_year["year"] != null
    //     ? `${round(previous_year["total_time"] / 3600)} hours in ${previous_year["year"]}` : "",
    //   color: '#C0F000',
    // },
    // {
    //   title: 'Total Elevation Gained',
    //   icon: 'fa-mountain',
    //   count: `${round(getDisplayElevation(total_elevation_gain))}${elevation_unit}`,
    //   subtitle: `You climbed Mount Everest ${round(total_elevation_gain / 8849, 1)} times`,
    //   previousYear: previous_year && previous_year["total_elevation_gain"] != null && previous_year["year"] != null
    //     ? `${round(getDisplayElevation(previous_year["total_elevation_gain"]))}${elevation_unit} in ${previous_year["year"]}` : "",
    //   color: '#FFBE0B',
    // },
    // {
    //   title: 'Indoor vs Outdoor Rides',
    //   icon: 'fa-door-open',
    //   count: `${round((indoor_rides / number_activities) * 100)}% inside vs ${round((outdoor_rides / number_activities) * 100)}% outside`,
    //   subtitle: indoor_rides > outdoor_rides ? 'Baby it\'s cold outside' : 'Nothing beats riding outside',
    //   previousYear: previous_year && previous_year["indoor_rides"] != null && previous_year["outdoor_rides"] != null && previous_year["number_activities"] != null && previous_year["year"] != null
    //     ? `${round((previous_year["indoor_rides"] / previous_year["number_activities"]) * 100)}% vs ${round((previous_year["outdoor_rides"] / previous_year["number_activities"]) * 100)}% in ${previous_year["year"]}` : "",
    //   color: '#00F5D4',
    // },
    // {
    //   title: 'Total Activities',
    //   icon: 'fa-bicycle',
    //   count: `${number_activities} activities`,
    //   subtitle: "Keep moving!",
    //   previousYear: previous_year && previous_year["number_activities"] != null && previous_year["year"] != null
    //     ? `${round(previous_year["number_activities"], 0)} activities in ${previous_year["year"]}` : "",
    //   color: '#9B5DE5',
    // },
    // {
    //   title: 'Total Active Days',
    //   icon: 'fa-calendar-check',
    //   count: `${number_active_days} days`,
    //   subtitle: number_active_days < 100 ? "Rest days are important too!" : "You're unstoppable!",
    //   previousYear: previous_year && previous_year["number_active_days"] != null && previous_year["year"] != null
    //     ? `${round(previous_year["number_active_days"], 0)} days in ${previous_year["year"]}` : "",
    //   color: '#F15BB5',
    // },
    // {
    //   title: 'Days on Forecast Plan',
    //   icon: 'fa-calendar-days',
    //   count: `${number_days_on_forecast_plan} days`,
    //   subtitle: number_days_on_forecast_plan < 100 ? "You can trust the plan!" : "You're following the plan well!",
    //   previousYear: previous_year && previous_year["number_days_on_forecast_plan"] != null && previous_year["year"] != null
    //     ? `${round(previous_year["number_days_on_forecast_plan"], 0)} days in ${previous_year["year"]}` : "",
    //   color: '#FF9F1C',
    // },
    // {
    //   title: 'Forecasted Rest Days',
    //   icon: 'fa-bed',
    //   count: `${number_forecasted_rest_days} days`,
    //   subtitle: number_forecasted_rest_days < 50 ? "You should rest more!" : "Good job taking rest days!",
    //   previousYear: previous_year && previous_year["number_forecasted_rest_days"] != null && previous_year["year"] != null
    //     ? `${round(previous_year["number_forecasted_rest_days"], 0)} days in ${previous_year["year"]}` : "",
    //   color: '#8AC926',
    // },
    // {
    //   title: 'Rest Days with Activity',
    //   icon: 'fa-walking',
    //   count: `${number_forecasted_rest_days_with_activity} days`,
    //   subtitle: number_forecasted_rest_days_with_activity > 20 ? "You can't help yourself!" : "Good job resting on rest days!",
    //   previousYear: previous_year && previous_year["number_forecasted_rest_days_with_activity"] != null && previous_year["year"] != null
    //     ? `${round(previous_year["number_forecasted_rest_days_with_activity"], 0)} days in ${previous_year["year"]}` : "",
    //   color: '#1982C4',
    // },
    // {
    //   title: 'Missed Training Days',
    //   icon: 'fa-person-running',
    //   count: `${number_forecasted_training_missed_days} days`,
    //   subtitle: number_forecasted_training_missed_days > 10 ? "Life gets in the way sometimes." : "Great job sticking to the plan!",
    //   previousYear: previous_year && previous_year["number_forecasted_training_missed_days"] != null && previous_year["year"] != null
    //     ? `${round(previous_year["number_forecasted_training_missed_days"], 0)} days in ${previous_year["year"]}` : "",
    //   color: '#6A4C93',
    // },
    number_green_circles > 0 ? {
      title: 'Total Green Training Circles',
      icon: 'fa-circle-check',
      count: `${number_green_circles} circles`,
      subtitle: number_green_circles > 10 ? "You're crushing it!" : "Keep pushing!",
      previousYear: previous_year && previous_year["number_green_circles"] != null && previous_year["year"] != null
        ? `${round(previous_year["number_green_circles"], 0)} circles in ${previous_year["year"]}` : "",
      color: '#00C49A',
    } : null,
    // {
    //   title: 'Yellow Training Circles',
    //   icon: 'fa-circle-exclamation',
    //   count: `${number_yellow_circles} circles`,
    //   subtitle: "You're almost there!",
    //   previousYear: previous_year && previous_year["number_yellow_circles"] != null && previous_year["year"] != null
    //     ? `${round(previous_year["number_yellow_circles"], 0)} circles in ${previous_year["year"]}` : "",
    //   color: '#FFBB28',
    // },
    // {
    //   title: 'Red Training Circles',
    //   icon: 'fa-circle-xmark',
    //   count: `${number_red_circles} circles`,
    //   subtitle: "Don't give up!",
    //   previousYear: previous_year && previous_year["number_red_circles"] != null && previous_year["year"] != null
    //     ? `${round(previous_year["number_red_circles"], 0)} circles in ${previous_year["year"]}` : "",
    //   color: '#FF8042',
    // }
  ].filter(fact => fact != null);

  let achievementsContainer;
  let achievementsScrollContainer;
  let activeAchievementIndex = 0;
  $: achievementsLooped = [...achievements, ...achievements, ...achievements];

  let factsContainer;
  let factsScrollContainer;
  let activeFactIndex = 0;
  $: factsLooped = [...facts, ...facts, ...facts];

  onMount(() => {
    // Start in the middle set
    activeAchievementIndex = achievements.length;
    achievementCardIsFlipped[activeAchievementIndex % originalAchievementsCount] = true;
    achievementsScrollContainer.scrollTo({ left: achievementCardWidth * activeAchievementIndex - (achievementsContainer.clientWidth - achievementCardWidth) / 2, behavior: 'auto' });

    activeFactIndex = facts.length;
    factCardIsFlipped[activeFactIndex % originalFactsCount] = true;
    factsScrollContainer.scrollTo({ left: factCardWidth * activeFactIndex - (factsContainer.clientWidth - factCardWidth) / 2, behavior: 'auto' });
  });

  const achievementCardWidth = 340;
  $: originalAchievementsCount = achievements.length;
  $: achievementCardIsFlipped = Array(originalAchievementsCount).fill(false);
  $: mobileAchievementCardIsFlipped = Array(originalAchievementsCount).fill(false);

  const factCardWidth = 340;
  $: originalFactsCount = facts.length;
  $: factCardIsFlipped = Array(originalFactsCount).fill(false);
  $: mobileFactCardIsFlipped = Array(originalFactsCount).fill(false);

  async function scrollAchievementsToIndex(index: number) {
    if (index <= originalAchievementsCount - 2) {
      index += originalAchievementsCount;
      achievementsScrollContainer.scrollBy({left: achievementCardWidth * originalAchievementsCount, behavior: 'auto'});
    } else if (index >= originalAchievementsCount * 2 + 1) {
      index -= originalAchievementsCount;
      achievementsScrollContainer.scrollBy({left: -achievementCardWidth * originalAchievementsCount, behavior: 'auto'});
    }

    await tick();

    activeAchievementIndex = index;
    achievementCardIsFlipped[activeAchievementIndex % originalAchievementsCount] = true;
    achievementsScrollContainer.scrollTo({ left: achievementCardWidth * activeAchievementIndex - (achievementsContainer.clientWidth - achievementCardWidth) / 2, behavior: 'smooth' });
  }

  async function scrollFactsToIndex(index: number) {
    if (index <= originalFactsCount - 2) {
      index += originalFactsCount;
      factsScrollContainer.scrollBy({left: factCardWidth * originalFactsCount, behavior: 'auto'});
    } else if (index >= originalFactsCount * 2 + 1) {
      index -= originalFactsCount;
      factsScrollContainer.scrollBy({left: -factCardWidth * originalFactsCount, behavior: 'auto'});
    }

    await tick();

    activeFactIndex = index;
    factCardIsFlipped[activeFactIndex % originalFactsCount] = true;
    factsScrollContainer.scrollTo({ left: factCardWidth * activeFactIndex - (factsContainer.clientWidth - factCardWidth) / 2, behavior: 'smooth' });
  }

  function inView(element, [onEnter, onLeave]) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.95) {
          onEnter?.();
        } else if (!entry.isIntersecting && entry.intersectionRatio <= 0.05) {
          onLeave?.();
        }
      });
    },
      { threshold: [0.05, 0.95] }
    );
    observer.observe(element);
    return { destroy() { observer.disconnect(); } };
  }

  function pageInView(element, pageName: PageType) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && currentPage !== pageName) {
          prevPage = currentPage;
          currentPage = pageName;
        }
      });
    },
      { threshold: [0.5] }
    );
    observer.observe(element);
    return { destroy() { observer.disconnect(); } };
  }

  function getKgeGrade(kge) {
    return 5/687 * (10**(1/3) *  (687 * Math.sqrt(3) * Math.sqrt(56636280000 * kge**2 - 111589200400 * kge + 54967962923) + 283181400 * kge - 278973001)**(1/3) - (7106 * 10**(2/3))/(687 * Math.sqrt(3) * Math.sqrt(56636280000 * kge**2 - 111589200400 * kge + 54967962923) + 283181400 * kge - 278973001)**(1/3) + 1430);
  }

</script>

<!-- <svelte:head>
  {#each Object.values(backgroundImages) as image}
    {#if typeof image === 'string'}
      {#if image.match(/\/assets[^"]+\.jpg/)}
        <link rel="preload" as="image" href={image.match(/\/assets[^"]+\.jpg/)[0]} />
      {/if}
    {/if}
  {/each}
</svelte:head> -->

<div bind:borderBoxSize={rootSize} class={cn('h-[100dvh] w-full overflow-y-scroll snap-y snap-mandatory scroll-smooth overscroll-contain relative text-off-white bg-cover text-left bg-black', useMobileLayout ? 'px-4' : 'px-20')}>
  {#key prevPage}
    <div class="fixed top-0 left-0 w-full h-full bg-cover fade-out"
      style='background-image: {backgroundImages[prevPage]}; background-repeat: no-repeat;
        background-position: {currentPage == 'title' ? '43%' : '50%'} 50%;'
    />
  {/key}
  {#key currentPage}
    <div class="fixed top-0 left-0 w-full h-full bg-cover fade-in"
      style='background-image: {backgroundImages[currentPage]}; background-repeat: no-repeat;
        background-position: {currentPage == 'title' ? '43%' : '50%'} 50%;'
    />
  {/key}
  <div class="fixed top-0 left-0 w-full h-full bg-cover"
    style='background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0.75) 100%); background-repeat: no-repeat;
      background-position: 50% 50%;'
  />

  <!-- TITLE SLIDE -->
  <section use:pageInView={'title'} class='h-[100dvh] p-0 snap-start snap-always flex flex-row-reverse flex-wrap justify-center items-center gap-8'>
    <div class='flex-1 min-w-[300px] max-w-[600px]'>
      <img src="/assets/yearly-report/images/banner-product.png" alt="logo" class="w-full object-contain"/>
    </div>
    <div class='flex flex-col flex-1 gap-8 h-max min-w-[300px] max-w-[600px]'>
      <div class='flex flex-col gap-1 text-6xl font-bold montserrat'>
        {#if !useMobileLayout}
          <span class="">{year}</span>
        {/if}
        <span class="text-[#5ee6e8]">Year in Review</span>
      </div>
      <p class="">See below for a collection of interesting facts and figures from your year on Xert! May {year + 1} bring you even greater achievements! </p>
    </div>
  </section>

  <!-- USER TOTALS + maybe comparisons (percentiles) -->
  <!-- Distance achievements
       42 - marathon
      180 - ironman
     ~530 - berlin to amsterdam
   ~1,100 - tour de california (not a thing anymore)
   ~3,500 - tour de france
   ~7,600 - across Canada
   10,921 - circumference of the moon
  ~19,000 - london to capetown cycling distance
   30,000 - pan american highway (alaska to argentina) 
   40,075 - circumference of the earth
  -->
  <section use:pageInView={'longest_distance'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
    <div class={cn(useMobileLayout ? 'w-[300px]' : 'w-[600px]')} use:inView={[() => revealLongestDistance = true, () => revealLongestDistance = false]}>
      <TotalDistanceCard
        year={year}
        distanceKm={total_distance}
        distanceUnit={distance_unit}
        revealed={revealLongestDistance}
        useMobileLayout={useMobileLayout}
      />
    </div>
  </section>

  {#if !useMobileLayout}
    <section use:pageInView={'totals'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
      <div class='flex flex-col h-full w-full max-w-[1140px] justify-center items-center'>
        <div class='flex flex-col items-center gap-1 text-5xl font-bold montserrat'>
          <span class="text-xl">Let's take a look at some of your</span>
          <span class="text-[#5ee6e8]">Yearly Totals</span>
        </div>
      </div>
      <div class='w-full max-w-[1140px] px-4 flex flex-row items-center justify-center gap-2'>
        <div class='w-[300px]' use:inView={[() => revealTotals1 = true, () => revealTotals1 = false]}>
          <TotalsActivityCard
            numberActivities={number_activities}
            numberActiveDays={number_active_days}
            indoorRides={indoor_rides}
            outdoorRides={outdoor_rides}
            xertWorkouts={xert_workouts}
            revealed={revealTotals1}
          />
        </div>
        <div class='w-[300px]' use:inView={[() => revealTotals2 = true, () => revealTotals2 = false]}>
          <TotalsTrainingCard
            totalDistance={getDisplayDistance(total_distance, distance_unit)}
            distanceUnit={distance_unit}
            totalElevation={getDisplayElevation(total_elevation_gain, elevation_unit)}
            elevationUnit={elevation_unit}
            totalTimeSeconds={total_time}
            totalXss={total_xss}
            revealed={revealTotals2}
          />
        </div>
        <div class='w-[300px]' use:inView={[() => revealTotals3 = true, () => revealTotals3 = false]}>
          <TotalsNutritionCard
            totalCarbs={total_carbs}
            totalFat={total_fat}
            revealed={revealTotals3}
          />
        </div>
      </div>
    </section>
  {:else}
    <!-- <section use:pageInView={'totals'} class='h-[100dvh] p-0 py-10 snap-start snap-always flex flex-col justify-center items-center gap-6'>
      <div class='flex flex-col items-center gap-1 text-5xl font-bold montserrat'>
        <span class="text-xl">Let's take a look at some of your</span>
        <span class="text-[#5ee6e8]">Yearly Totals</span>
      </div>
    </section> -->
    <section use:pageInView={'totals'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
      <div class='w-[300px]' use:inView={[() => revealTotals2 = true, () => revealTotals2 = false]}>
        <TotalsTrainingCard
          totalDistance={getDisplayDistance(total_distance, distance_unit)}
          distanceUnit={distance_unit}
          totalElevation={getDisplayElevation(total_elevation_gain, elevation_unit)}
          elevationUnit={elevation_unit}
          totalTimeSeconds={total_time}
          totalXss={total_xss}
          revealed={revealTotals2}
        />
      </div>
    </section>
    <section use:pageInView={'totals'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
      <div class='w-[300px]' use:inView={[() => revealTotals1 = true, () => revealTotals1 = false]}>
        <TotalsActivityCard
          numberActivities={number_activities}
          numberActiveDays={number_active_days}
          indoorRides={indoor_rides}
          outdoorRides={outdoor_rides}
          xertWorkouts={xert_workouts}
          revealed={revealTotals1}
        />
      </div>
    </section>
    <section use:pageInView={'totals'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
      <div class='w-[300px]' use:inView={[() => revealTotals3 = true, () => revealTotals3 = false]}>
        <TotalsNutritionCard
          totalCarbs={total_carbs}
          totalFat={total_fat}
          revealed={revealTotals3}
        />
      </div>
    </section>
  {/if}

  <!-- USER RECORDS -->
  {#if !useMobileLayout}
    <section use:pageInView={'power_records'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
      <div class='flex flex-row items-center gap-10 flex-wrap'>
        <div class='flex flex-col gap-1 text-5xl font-bold montserrat'>
          <span class="text-xl">You had a lot of big efforts this year!</span>
          <span class="text-[#5ee6e8]">Season Records</span>
        </div>
        <div class='flex-1'/>
        <div class='flex flex-row items-center gap-10'>
          <div class='flex flex-col items-center gap-2 text-off-white'>
            <i class="h-[12px] fa-regular fa-trophy fa-lg text-[gold]"></i>
            <span class="text-5xl font-medium">{gold_brs}</span>
            <span class='text-sm font-medium text-center'>Gold<br/>Breakthroughs</span>
          </div>
          <div class='flex flex-col items-center gap-2 text-off-white'>
            <i class="h-[12px] fa-regular fa-trophy fa-lg text-[silver]"></i>
            <span class="text-5xl font-medium">{silver_brs}</span>
            <span class='text-sm font-medium text-center'>Silver<br/>Breakthroughs</span>
          </div>
          <div class='flex flex-col items-center gap-2 text-off-white'>
            <i class="h-[12px] fa-regular fa-trophy fa-lg text-[#cd7f32]"></i>
            <span class="text-5xl font-medium">{bronze_brs}</span>
            <span class='text-sm font-medium text-center'>Bronze<br/>Breakthroughs</span>
          </div>
        </div>
      </div>
      <div class='w-[300px]' use:inView={[() => revealRecords2 = true, () => revealRecords2 = false]}>
        <RecordsPowerCard
          ftpWatts={max_signature_ftp_p?.signature?.ftp}
          maxPowerWatts={max_power_a?.sessions?.[0]?.max_power}
          revealed={revealRecords2}
        />
      </div>
    </section>
    <section use:pageInView={'strain_records'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
      <div class='w-[600px]' use:inView={[() => revealRecords1 = true, () => revealRecords1 = false]}>
        <RecordsStrainCard
          maxXss={max_xss_a?.xss}
          maxXhss={max_xhss_a?.xhss}
          maxXpss={max_xpss_a?.xpss}
          revealed={revealRecords1}
          useMobileLayout={useMobileLayout}
        />
      </div>
    </section>
    <section use:pageInView={'terrain_records'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
      <div class='w-[600px]' use:inView={[() => revealRecords3 = true, () => revealRecords3 = false]}>
        <RecordsTerrainCard
          steepestSlope={max_kge_a ? getKgeGrade(max_kge_a?.kge): 0}
          kgeChangeWatts={kge_change}
          longestDistance={getDisplayDistance(max_distance_a?.distance, distance_unit)}
          distanceUnit={distance_unit}
          revealed={revealRecords3}
          useMobileLayout={useMobileLayout}
        />
      </div>
    </section>
  {:else}
    <!-- <section use:pageInView={'power_records'} class='h-[100dvh] p-0 py-10 snap-start snap-always flex flex-col justify-center items-center gap-6'>
      <div class='flex flex-col gap-1 text-5xl font-bold montserrat'>
        <span class="text-xl">You had a lot of big efforts this year!</span>
        <span class="text-[#5ee6e8]">Season Records</span>
      </div>
    </section> -->
    <section use:pageInView={'power_records'} class='h-[100dvh] p-0 py-10 snap-start snap-always flex flex-col justify-center items-center gap-6'>
      <div class='w-[300px]' use:inView={[() => revealBreakthroughs = true, () => revealBreakthroughs = false]}>
        <BreakThroughsCard
          goldCount={gold_brs}
          silverCount={silver_brs}
          bronzeCount={bronze_brs}
          revealed={revealBreakthroughs}
          useMobileLayout={useMobileLayout}
        />
       </div>
    </section>
    <section use:pageInView={'power_records'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
      <div class='w-[300px]' use:inView={[() => revealRecords2 = true, () => revealRecords2 = false]}>
        <RecordsPowerCard
          ftpWatts={max_signature_ftp_p?.signature?.ftp}
          maxPowerWatts={max_power_a?.sessions?.[0]?.max_power}
          revealed={revealRecords2}
        />
      </div>
    </section>
    <section use:pageInView={'strain_records'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
      <div class='w-[300px]' use:inView={[() => revealRecords1 = true, () => revealRecords1 = false]}>
        <RecordsStrainCard
          maxXss={max_xss_a?.xss}
          maxXhss={max_xhss_a?.xhss}
          maxXpss={max_xpss_a?.xpss}
          revealed={revealRecords1}
          useMobileLayout={useMobileLayout}
        />
      </div>
    </section>
    <section use:pageInView={'terrain_records'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
      <div class='w-[300px]' use:inView={[() => revealRecords3 = true, () => revealRecords3 = false]}>
        <RecordsTerrainCard
          steepestSlope={max_kge_a ? getKgeGrade(max_kge_a?.kge): 0}
          kgeChangeWatts={kge_change}
          longestDistance={getDisplayDistance(max_distance_a?.distance, distance_unit)}
          distanceUnit={distance_unit}
          revealed={revealRecords3}
          useMobileLayout={useMobileLayout}
        />
      </div>
    </section>
  {/if}

  <!-- ACTIVITY ACHIEVEMENTS SLIDE -->
  {#if !useMobileLayout}
    <section use:pageInView={'best_activities'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
      <div class='flex flex-col h-full w-full max-w-[1140px]'>
        <div class='flex flex-col items-center gap-1 text-5xl font-bold montserrat'>
          <span class="text-xl">Let's see where these records happened...</span>
          <span class="text-[#5ee6e8]">Best Activities</span>
        </div>
        <div bind:this={achievementsContainer} class='flex-1 flex flex-row items-center w-full'>
          <Button variant='ghost' class='w-8 h-20 text-off-white' on:click={() => scrollAchievementsToIndex(activeAchievementIndex - 1)}>
            <i class="fas fa-4xl fa-chevron-left"></i>
          </Button>
          <div bind:this={achievementsScrollContainer} class='flex flex-row items-center overflow-x-hidden overflow-y-hidden snap-x snap-mandatory no-scrollbar'>
            {#each achievementsLooped as { title, subtitle, activity }, index}
              <div class='w-[340px] snap-center flex-shrink-0 flex items-center justify-center'>
                <AchievementCard {title} {subtitle} {activity} isFlipped={achievementCardIsFlipped[index % originalAchievementsCount]} isActive={activeAchievementIndex % originalAchievementsCount === index % originalAchievementsCount} />
              </div>
            {/each}
          </div>
          <Button variant='ghost' class='w-8 h-20 text-off-white' on:click={() => scrollAchievementsToIndex(activeAchievementIndex + 1)}>
            <i class="fas fa-4xl fa-chevron-right"></i>
          </Button>
        </div>
      </div>
    </section>
  {:else}
    <section use:pageInView={'best_activities'} class='h-[100dvh] p-0 py-10 snap-start snap-always flex flex-col justify-center items-center gap-6'>
      <div class='flex flex-col items-center gap-1 text-5xl font-bold montserrat'>
        <span class="text-xl text-center">Let's take a look at your</span>
        <span class="text-[#5ee6e8] text-center">Best Activities</span>
      </div>
    </section>
    {#each achievements as { title, subtitle, activity }, index}
      <section use:pageInView={'best_activities'} use:inView={[() => {mobileAchievementCardIsFlipped[index % originalAchievementsCount] = true; mobileAchievementCardIsFlipped = mobileAchievementCardIsFlipped}, () => {mobileAchievementCardIsFlipped[index % originalAchievementsCount] = false; mobileAchievementCardIsFlipped = mobileAchievementCardIsFlipped; }]} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
        <AchievementCard {title} {subtitle} {activity} isFlipped={mobileAchievementCardIsFlipped[index % originalAchievementsCount]} isActive={true} />
      </section>
    {/each}
  {/if}

  <!-- TRAINING PLANS (completion percentages, rest days) -->
  {#if number_days_on_forecast_plan > 0}
    {#if !useMobileLayout}
      <section use:pageInView={'training_plan'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
        <div class='flex flex-col w-full max-w-[1140px] justify-center items-center'>
          <div class='flex flex-col items-center gap-1 text-5xl font-bold montserrat'>
            <span class="text-xl">It's good to plan ahead!</span>
            <span class="text-[#5ee6e8]">Training Plan</span>
          </div>
        </div>
        <div class='w-full max-w-[1140px] px-4 flex flex-row items-center justify-center gap-2'>
          {#if number_forecasted_rest_days_with_activity > 0 && longest_green_circles_streak >= 3}
            <div class='w-[300px] card-hidden {revealTrainingPlan1 ? 'pop-in' : ''}' use:inView={[() => revealTrainingPlanTimeout1 = setTimeout(() => revealTrainingPlan1 = true, 3000), () => {revealTrainingPlan1 = false; clearTimeout(revealTrainingPlanTimeout1);} ]}>
              <TrainingPlanRestCard
                restDaysWithActivity={number_forecasted_rest_days_with_activity}
                totalRestDays={number_forecasted_rest_days}
                revealed={revealTrainingPlan1}
              />
            </div>
          {/if}
          <div class='w-[300px]' use:inView={[() => revealTrainingPlan2 = true, () => revealTrainingPlan2 = false]}>
            <TrainingPlanAdherenceCard
              daysOnPlan={number_days_on_forecast_plan}
              daysWithForecastedTraining={number_days_on_forecast_plan - number_forecasted_rest_days}
              missedDays={number_forecasted_training_missed_days}
              revealed={revealTrainingPlan2}
            />
          </div>
          {#if longest_green_circles_streak >= 3}
            <div class='w-[300px] card-hidden {revealTrainingPlan3 ? 'pop-in' : ''}' use:inView={[() => revealTrainingPlanTimeout3 = setTimeout(() => revealTrainingPlan3 = true, 1500), () => {revealTrainingPlan3 = false; clearTimeout(revealTrainingPlanTimeout3);} ]}>
              <TrainingPlanStreakCard
                longestGreenStreak={longest_green_circles_streak}
                greenCircles={number_green_circles}
                revealed={revealTrainingPlan3}
              />
            </div>
          {:else if number_forecasted_rest_days_with_activity > 0}
            <div class='w-[300px] card-hidden {revealTrainingPlan1 ? 'pop-in' : ''}' use:inView={[() => revealTrainingPlanTimeout1 = setTimeout(() => revealTrainingPlan1 = true, 1500), () => {revealTrainingPlan1 = false; clearTimeout(revealTrainingPlanTimeout1);} ]}>
              <TrainingPlanRestCard
                restDaysWithActivity={number_forecasted_rest_days_with_activity}
                totalRestDays={number_forecasted_rest_days}
                revealed={revealTrainingPlan1}
              />
            </div>
          {/if}
        </div>
      </section>
    {:else}
      <!-- <section use:pageInView={'training_plan'} class='h-[100dvh] p-0 py-10 snap-start snap-always flex flex-col justify-center items-center gap-6'>
        <div class='flex flex-col items-center gap-1 text-5xl font-bold montserrat'>
          <span class="text-xl">It's good to plan ahead!</span>
          <span class="text-[#5ee6e8]">Training Plan</span>
        </div>
      </section> -->
      <section use:pageInView={'training_plan'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
        <div class='w-[300px]' use:inView={[() => revealTrainingPlan2 = true, () => revealTrainingPlan2 = false]}>
          <TrainingPlanAdherenceCard
            daysOnPlan={number_days_on_forecast_plan}
            daysWithForecastedTraining={number_days_on_forecast_plan - number_forecasted_rest_days}
            missedDays={number_forecasted_training_missed_days}
            revealed={revealTrainingPlan2}
          />
        </div>
      </section>
      {#if longest_green_circles_streak >= 3}
        <section use:pageInView={'training_plan'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
          <div class='w-[300px]' use:inView={[() => revealTrainingPlan3 = true, () => revealTrainingPlan3 = false]}>
            <TrainingPlanStreakCard
              longestGreenStreak={longest_green_circles_streak}
              greenCircles={number_green_circles}
              revealed={revealTrainingPlan3}
            />
          </div>
        </section>
      {/if}
      {#if number_forecasted_rest_days_with_activity > 0}
        <section use:pageInView={'training_plan'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
          <div class='w-[300px]' use:inView={[() => revealTrainingPlan1 = true, () => revealTrainingPlan1 = false]}>
            <TrainingPlanRestCard
              restDaysWithActivity={number_forecasted_rest_days_with_activity}
              totalRestDays={number_forecasted_rest_days}
              revealed={revealTrainingPlan1}
            />
          </div>
        </section>
      {/if}
    {/if}
  {/if}

  <!-- GROUP RIDES -->
  {#if number_group_rides > 0}
    {#if !useMobileLayout}
      <section use:pageInView={'group_activities'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
        <div class='flex flex-col w-full max-w-[1140px] justify-center items-center'>
          <div class='flex flex-col items-center gap-1 text-5xl font-bold montserrat'>
            <span class="text-xl">Nothing like some friendly competition!</span>
            <span class="text-[#5ee6e8]">Group Activities</span>
          </div>
        </div>
        <div class='w-[300px]' use:inView={[() => revealGroup = true, () => revealGroup = false]}>
          <GroupActivitiesCard
            number_group_rides={number_group_rides}
            biggestGroupRide={biggest_group_ride}
            revealed={revealGroup}
          />
        </div>
      </section>
    {:else}
      <!-- <section use:pageInView={'group_activities'} class='h-[100dvh] p-0 py-10 snap-start snap-always flex flex-col justify-center items-center gap-6'>
        <div class='flex flex-col items-center gap-1 text-5xl font-bold montserrat'>
          <span class="text-xl">Nothing like some friendly competition!</span>
          <span class="text-[#5ee6e8]">Group Activities</span>
        </div>
      </section> -->
      <section use:pageInView={'group_activities'} class='h-[100dvh] p-0 py-10 snap-start snap-always flex flex-col justify-center items-center gap-6'>
        <div class='w-[300px]' use:inView={[() => revealGroup = true, () => revealGroup = false]}>
          <GroupActivitiesCard
            number_group_rides={number_group_rides}
            biggestGroupRide={biggest_group_ride}
            revealed={revealGroup}
          />
        </div>
      </section>
    {/if}
  {/if}

  <!-- XERT ALL USER AVERAGES -->
  {#if !useMobileLayout}
    <section use:pageInView={'global_averages'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
      <div class='flex flex-col w-full max-w-[1140px] justify-center items-center'>
        <div class='flex flex-col items-center gap-1 text-5xl font-bold montserrat'>
          <span class="text-xl">How did we do against {year - 1}?</span>
          <span class="text-[#5ee6e8]">Global Averages</span>
        </div>
      </div>
      <div class='w-full max-w-[1140px] px-4 flex flex-row items-center justify-center gap-2'>
        <div class='w-[300px]' use:inView={[() => revealGlobalSignature = true, () => revealGlobalSignature = false]}>
          <GlobalAverageSignatureCard
            globalMaleAvgFtp={AVERAGES_MALE.avg_highest_threshold_power}
            globalMaleAvgPp={AVERAGES_MALE.avg_highest_peak_power}
            globalMaleAvgHie={AVERAGES_MALE.avg_highest_hie}
            globalMaleAvgFtp2024={AVERAGES_MALE_2024.avg_highest_threshold_power}
            globalMaleAvgPp2024={AVERAGES_MALE_2024.avg_highest_peak_power}
            globalMaleAvgHie2024={AVERAGES_MALE_2024.avg_highest_hie}
            globalFemaleAvgFtp={AVERAGES_FEMALE.avg_highest_threshold_power}
            globalFemaleAvgPp={AVERAGES_FEMALE.avg_highest_peak_power}
            globalFemaleAvgHie={AVERAGES_FEMALE.avg_highest_hie}
            globalFemaleAvgFtp2024={AVERAGES_FEMALE_2024.avg_highest_threshold_power}
            globalFemaleAvgPp2024={AVERAGES_FEMALE_2024.avg_highest_peak_power}
            globalFemaleAvgHie2024={AVERAGES_FEMALE_2024.avg_highest_hie}
            userFtp={max_signature_ftp_p?.signature?.ftp}
            userPp={max_signature_pp?.signature?.pp}
            userHie={round((max_signature_hie?.signature?.atc ?? 0) / 1000, 1)}
            revealed={revealGlobalSignature}
          />
        </div>
        <div class='w-[300px] h-full' use:inView={[() => revealGlobalOther = true, () => revealGlobalOther = false]}>
          <GlobalAverageOtherCard
          globalMaleAvgWattsPerKg={AVERAGES_MALE.watts_per_kg}
          globalMaleAvgActivities={AVERAGES_MALE.number_activities}
          globalMaleAvgDistance={getDisplayDistance(AVERAGES_MALE.yearly_distance_km, distance_unit)}
          globalFemaleAvgWattsPerKg={AVERAGES_FEMALE.watts_per_kg}
          globalFemaleAvgActivities={AVERAGES_FEMALE.number_activities}
          globalFemaleAvgDistance={getDisplayDistance(AVERAGES_FEMALE.yearly_distance_km, distance_unit)}
          globalMaleAvgWattsPerKg2024={AVERAGES_MALE_2024.watts_per_kg}
          globalMaleAvgActivities2024={AVERAGES_MALE_2024.number_activities}
          globalMaleAvgDistance2024={getDisplayDistance(AVERAGES_MALE_2024.yearly_distance_km, distance_unit)}
          globalFemaleAvgWattsPerKg2024={AVERAGES_FEMALE_2024.watts_per_kg}
          globalFemaleAvgActivities2024={AVERAGES_FEMALE_2024.number_activities}
          globalFemaleAvgDistance2024={getDisplayDistance(AVERAGES_FEMALE_2024.yearly_distance_km, distance_unit)}
          globalAvgActivities={AVERAGES_ALL.number_activities}
          globalAvgActivities2024={AVERAGES_ALL_2024.number_activities}
          globalAvgDistance={getDisplayDistance(AVERAGES_ALL.yearly_distance_km, distance_unit)}
          globalAvgDistance2024={getDisplayDistance(AVERAGES_ALL_2024.yearly_distance_km, distance_unit)}
          userWattsPerKg={max_watts_per_kg?.signature?.ftp / max_watts_per_kg?.weight}
          userActivities={number_activities}
          userDistance={getDisplayDistance(total_distance, distance_unit)}
          distanceUnit={distance_unit}
          revealed={revealGlobalOther}
        />
        </div>
      </div>
    </section>
  {:else}
    <!-- <section use:pageInView={'title'} class='h-[100dvh] p-0 py-10 snap-start snap-always flex flex-col justify-center items-center gap-6'>
      <div class='flex flex-col items-center gap-1 text-5xl font-bold montserrat'>
        <span class="text-xl">How do you compare?</span>
        <span class="text-[#5ee6e8]">Global Averages</span>
      </div>
    </section> -->
    <section use:pageInView={'global_averages'} class='h-[100dvh] p-0 py-10 snap-start snap-always flex flex-col justify-center items-center gap-6'>
      <div class='w-[300px]' use:inView={[() => revealGlobalSignature = true, () => revealGlobalSignature = false]}>
        <GlobalAverageSignatureCard
          globalMaleAvgFtp={AVERAGES_MALE.avg_highest_threshold_power}
          globalMaleAvgPp={AVERAGES_MALE.avg_highest_peak_power}
          globalMaleAvgHie={AVERAGES_MALE.avg_highest_hie}
          globalMaleAvgFtp2024={AVERAGES_MALE_2024.avg_highest_threshold_power}
          globalMaleAvgPp2024={AVERAGES_MALE_2024.avg_highest_peak_power}
          globalMaleAvgHie2024={AVERAGES_MALE_2024.avg_highest_hie}
          globalFemaleAvgFtp={AVERAGES_FEMALE.avg_highest_threshold_power}
          globalFemaleAvgPp={AVERAGES_FEMALE.avg_highest_peak_power}
          globalFemaleAvgHie={AVERAGES_FEMALE.avg_highest_hie}
          globalFemaleAvgFtp2024={AVERAGES_FEMALE_2024.avg_highest_threshold_power}
          globalFemaleAvgPp2024={AVERAGES_FEMALE_2024.avg_highest_peak_power}
          globalFemaleAvgHie2024={AVERAGES_FEMALE_2024.avg_highest_hie}
          userFtp={max_signature_ftp_p?.signature?.ftp}
          userPp={max_signature_pp?.signature?.pp}
          userHie={round((max_signature_hie?.signature?.atc ?? 0) / 1000, 1)}
          revealed={revealGlobalSignature}
        />
      </div>
    </section>
    <section use:pageInView={'global_averages'} class='h-[100dvh] p-0 py-10 snap-start snap-always flex flex-col justify-center items-center gap-6'>
      <div class='w-[300px]' use:inView={[() => revealGlobalOther = true, () => revealGlobalOther = false]}>
        <GlobalAverageOtherCard
          globalMaleAvgWattsPerKg={AVERAGES_MALE.watts_per_kg}
          globalMaleAvgActivities={AVERAGES_MALE.number_activities}
          globalMaleAvgDistance={getDisplayDistance(AVERAGES_MALE.yearly_distance_km, distance_unit)}
          globalFemaleAvgWattsPerKg={AVERAGES_FEMALE.watts_per_kg}
          globalFemaleAvgActivities={AVERAGES_FEMALE.number_activities}
          globalFemaleAvgDistance={getDisplayDistance(AVERAGES_FEMALE.yearly_distance_km, distance_unit)}
          globalMaleAvgWattsPerKg2024={AVERAGES_MALE_2024.watts_per_kg}
          globalMaleAvgActivities2024={AVERAGES_MALE_2024.number_activities}
          globalMaleAvgDistance2024={getDisplayDistance(AVERAGES_MALE_2024.yearly_distance_km, distance_unit)}
          globalFemaleAvgWattsPerKg2024={AVERAGES_FEMALE_2024.watts_per_kg}
          globalFemaleAvgActivities2024={AVERAGES_FEMALE_2024.number_activities}
          globalFemaleAvgDistance2024={getDisplayDistance(AVERAGES_FEMALE_2024.yearly_distance_km, distance_unit)}
          globalAvgActivities={AVERAGES_ALL.number_activities}
          globalAvgActivities2024={AVERAGES_ALL_2024.number_activities}
          globalAvgDistance={getDisplayDistance(AVERAGES_ALL.yearly_distance_km, distance_unit)}
          globalAvgDistance2024={getDisplayDistance(AVERAGES_ALL_2024.yearly_distance_km, distance_unit)}
          userWattsPerKg={max_watts_per_kg?.signature?.ftp / max_watts_per_kg?.weight}
          userActivities={number_activities}
          userDistance={getDisplayDistance(total_distance, distance_unit)}
          distanceUnit={distance_unit}
          revealed={revealGlobalOther}
        />
      </div>
    </section>
  {/if}

  <!-- INTERESTING FACTS SLIDE -->
  {#if !useMobileLayout}
    <section use:pageInView={'data'} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
      <div class='flex flex-col h-full w-full max-w-[1140px] justify-center items-center'>
        <div class='flex flex-col items-center gap-1 text-5xl font-bold montserrat'>
          <span class="text-xl">Here's a few more</span>
          <span class="text-[#5ee6e8]">Fun Facts!</span>
        </div>
        <div bind:this={factsContainer} class='h-[400px] flex flex-row items-center w-full'>
          <Button variant='ghost' class='w-8 h-20 text-off-white' on:click={() => scrollFactsToIndex(activeFactIndex - 1)}>
            <i class="fas fa-4xl fa-chevron-left"></i>
          </Button>
          <div bind:this={factsScrollContainer} class='flex flex-row items-center overflow-x-hidden overflow-y-hidden snap-x snap-mandatory no-scrollbar'>
            {#each factsLooped as { title, icon, count, subtitle, previousYear, color }, index}
              <div class='w-[340px] snap-center flex-shrink-0 flex items-center justify-center'>
                <FactCard {title} {icon} {count} {subtitle} {previousYear} {color} isFlipped={factCardIsFlipped[index % originalFactsCount]} isActive={activeFactIndex % originalFactsCount === index % originalFactsCount} />
              </div>
            {/each}
          </div>
          <Button variant='ghost' class='w-8 h-20 text-off-white' on:click={() => scrollFactsToIndex(activeFactIndex + 1)}>
            <i class="fas fa-4xl fa-chevron-right"></i>
          </Button>
        </div>
      </div>
    </section>
  {:else}
    <section use:pageInView={'data'} class='h-[100dvh] p-0 py-10 snap-start snap-always flex flex-col justify-center items-center gap-6'>
      <div class='flex flex-col items-center gap-1 text-5xl font-bold montserrat'>
        <span class="text-xl text-center">Here's a few more</span>
        <span class="text-[#5ee6e8] text-center">Fun Facts!</span>
      </div>
    </section>
    {#each facts as { title, icon, count, subtitle, previousYear, color }, index}
      <section use:pageInView={'best_activities'} use:inView={[() => {mobileFactCardIsFlipped[index % originalFactsCount] = true; mobileFactCardIsFlipped = mobileFactCardIsFlipped}, () => {mobileFactCardIsFlipped[index % originalFactsCount] = false; mobileFactCardIsFlipped = mobileFactCardIsFlipped; }]} class='h-[100dvh] p-0 py-14 snap-start snap-always flex flex-col justify-center items-center gap-8'>
        <FactCard {title} {icon} {count} {subtitle} {previousYear} {color} isFlipped={mobileFactCardIsFlipped[index % originalFactsCount]} isActive={true} />
      </section>
    {/each}
  {/if}

  <!-- FINAL SLIDE -->
  <section use:pageInView={'last'}
    class='h-[100dvh] p-0 snap-start snap-always flex flex-col justify-center gap-8'>
    {#if useMobileLayout}
      <div class='flex flex-col items-center text-center gap-6 px-4'>
        <div class='flex flex-col gap-1 text-4xl font-bold montserrat'>
          <span>Congratulations!</span>
          <span class="text-[#5ee6e8]">Best of Luck in {year + 1}!</span>
        </div>
        <div class="flex flex-col gap-4 max-w-[320px]">
          <span class="text-2xl montserrat">Xert Breakthrough Training</span>
          <p class="p-0 text-sm">Discover. Improve. Perform.</p>
          <p class="text-sm"><i aria-hidden="true" class="fas fa-lg fa-paper-plane mr-1"></i>support@xertonline.com</p>
        </div>
        <div class='flex flex-row flex-wrap items-center justify-center gap-2'>
          <Button variant='ghost' size='icon' class='text-off-white' href="https://www.facebook.com/groups/XertUsers" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-facebook-f"></i></Button>
          <Button variant='ghost' size='icon' class='text-off-white' href="https://www.twitter.com/baronbiosys" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-twitter"></i></Button>
          <Button variant='ghost' size='icon' class='text-off-white' href="https://forum.xertonline.com" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-discourse"></i></Button>
          <Button variant='ghost' size='icon' class='text-off-white' href="https://www.instagram.com/xert.bt.boom/" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-instagram"></i></Button>
          <Button variant='ghost' size='icon' class='text-off-white' href="https://www.youtube.com/XertAcademyVideos/" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-youtube"></i></Button>
          <Button variant='ghost' size='icon' class='text-off-white' href="https://www.strava.com/clubs/xert" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-strava"></i></Button>
        </div>
      </div>
    {:else}
      <div class='flex flex-col gap-1 text-5xl font-bold montserrat'>
        <span class="">Congratulations!</span>
        <span class="text-[#5ee6e8]">Best of Luck in {year + 1}!</span>
      </div>
      <div class="flex flex-col gap-6">
        <span class="text-3xl montserrat">Xert Breakthrough Training</span>
        <p class="p-0">Discover. Improve. Perform.</p>
        <p class="text-base"><i aria-hidden="true" class="fas fa-lg fa-paper-plane mr-1"></i>support@xertonline.com</p>
      </div>
      <div class='flex flex-row gap-2'>
        <Button variant='ghost' size='icon' class='text-off-white' href="https://www.facebook.com/groups/XertUsers" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-facebook-f"></i></Button>
        <Button variant='ghost' size='icon' class='text-off-white' href="https://www.twitter.com/baronbiosys" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-twitter"></i></Button>
        <Button variant='ghost' size='icon' class='text-off-white' href="https://forum.xertonline.com" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-discourse"></i></Button>
        <Button variant='ghost' size='icon' class='text-off-white' href="https://www.instagram.com/xert.bt.boom/" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-instagram"></i></Button>
        <Button variant='ghost' size='icon' class='text-off-white' href="https://www.youtube.com/XertAcademyVideos/" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-youtube"></i></Button>
        <Button variant='ghost' size='icon' class='text-off-white' href="https://www.strava.com/clubs/xert" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-strava"></i></Button>
      </div>
    {/if}
  </section>

  <!-- COPYRIGHT and SOCIALS -->
  <div class='fixed top-0 right-0 md:top-2 md:right-2 w-max flex flex-row gap-2'>
    <Button variant='ghost' size='icon' class='text-off-white' href="https://www.facebook.com/groups/XertUsers" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-facebook-f"></i></Button>
    <Button variant='ghost' size='icon' class='text-off-white' href="https://www.twitter.com/baronbiosys" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-twitter"></i></Button>
    <Button variant='ghost' size='icon' class='text-off-white' href="https://forum.xertonline.com" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-discourse"></i></Button>
    <Button variant='ghost' size='icon' class='text-off-white' href="https://www.instagram.com/xert.bt.boom/" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-instagram"></i></Button>
    <Button variant='ghost' size='icon' class='text-off-white' href="https://www.youtube.com/XertAcademyVideos/" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-youtube"></i></Button>
    <Button variant='ghost' size='icon' class='text-off-white' href="https://www.strava.com/clubs/xert" target="_blank" rel="noopener noreferrer"><i class="fab fa-lg fa-strava"></i></Button>
  </div>
  <div class='fixed bottom-0 right-0 md:bottom-2 md:right-2 text-off-white'>
    © Baron Biosystems Ltd. 2025.
  </div>
</div>

<style>
  .montserrat {
    font-family: 'Montserrat', sans-serif;
  }

  .pop-in{
    transform-origin: center center;
    animation: pop-in-key 500ms ease-out both;
  }
  @keyframes pop-in-key {
    0% { transform: scale(0); opacity: 0; }
    60% { transform: scale(1.05); opacity: 1; }
    100% { transform: scale(1); opacity: 1; }
  }

  .card-hidden {
    opacity: 0;
  }

  .fade-in {
    animation: fade-in-key 1000ms ease-out both;
  }
  @keyframes fade-in-key {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  .fade-out {
    animation: fade-out-key 1000ms ease-out both;
  }
  @keyframes fade-out-key {
    0% { opacity: 1; }
    100% { opacity: 0; }
  }

</style>
